var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full-screen" }, [
    _c("div", { staticClass: "outer" }, [
      _c(
        "div",
        { staticClass: "left-side" },
        [
          _c(
            "div",
            { staticClass: "button-row" },
            [
              _c(
                "div",
                {
                  staticClass: "dimension-button",
                  class: "" + (_vm.listToShow == "merged" ? "on" : "off"),
                  on: {
                    click: function($event) {
                      return _vm.displayMerged()
                    },
                    contextmenu: function($event) {
                      return _vm.getMoreMembers($event)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: require("../../../static/p.png") }
                  }),
                  _c("br"),
                  _vm._v(
                    "\n\t\t\t\t\t" + _vm._s(_vm.totalResults) + "\n\t\t\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.dimensions, function(dim) {
                return _c(
                  "div",
                  {
                    key: dim.name,
                    staticClass: "dimension-button",
                    class: "" + (_vm.listToShow == dim.name ? "on" : "off"),
                    style:
                      "background-color: " +
                      (dim.totalResults >= 0 ? "#bcdbf6" : "#e9f3fc"),
                    on: {
                      click: function($event) {
                        return _vm.displayResults(dim)
                      }
                    }
                  },
                  [
                    dim.imageURL
                      ? _c("img", { attrs: { src: dim.imageURL } })
                      : _vm._e(),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(dim.totalResults > 0 ? dim.totalResults : "") +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.listToShow == "merged",
                  expression: "listToShow == 'merged'"
                }
              ]
            },
            [
              _c(
                "div",
                {
                  ref: "weights",
                  staticClass: "weight-box",
                  on: {
                    mousemove: function($event) {
                      return _vm.adjustWeight($event)
                    },
                    mouseleave: function($event) {
                      return _vm.stopAdjustWeight()
                    },
                    mouseup: function($event) {
                      return _vm.stopAdjustWeight()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "adjuster",
                      on: {
                        click: function($event) {
                          _vm.showIntents = !_vm.showIntents
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.intentText) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showIntents
                    ? _c(
                        "div",
                        { staticClass: "picker intent-picker" },
                        _vm._l(_vm.weightPresets, function(preset) {
                          return _c(
                            "div",
                            {
                              key: preset["intent"],
                              staticClass: "button-row",
                              on: {
                                click: function($event) {
                                  return _vm.pickIntent(preset)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "picklist-item",
                                  staticStyle: { "flex-grow": "10" }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(preset["intent"]) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.dimensions, function(dim) {
                    return _c(
                      "div",
                      {
                        key: "btn-" + dim.name,
                        staticClass: "weight",
                        on: {
                          mousedown: function($event) {
                            return _vm.startAdjustWeight(dim, $event)
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "weight-column",
                          style:
                            "background-color: " +
                            (dim.totalResults <= 0 ? "#cccccc" : dim.color) +
                            ";height:" +
                            dim.weight +
                            "px"
                        }),
                        _vm._v(" "),
                        dim.totalResults > 0
                          ? _c("div", { staticClass: "weight-number" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(dim.weight) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _vm.listToShow != "merged" &&
          _vm.ask.matchingCriteria &&
          _vm.matchingCriteriaDim &&
          _vm.matchingCriteriaDim.terms
            ? _c(
                "div",
                { staticClass: "term-row" },
                [
                  _vm._l(_vm.matchingCriteriaDim.terms, function(term, idx) {
                    return _c(
                      "div",
                      {
                        key: term.term + idx,
                        staticClass: "term",
                        style: "color:" + _vm.termColor,
                        on: {
                          click: function($event) {
                            return _vm.displayTermPanel(idx)
                          },
                          contextmenu: function($event) {
                            return _vm.removeTerm(idx, $event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              term.required
                                ? term.term.toUpperCase()
                                : term.term
                            ) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "term",
                      style: "color:" + _vm.termColor,
                      on: {
                        click: function($event) {
                          return _vm.displayAddTerm()
                        }
                      }
                    },
                    [_vm._v("\n\t\t\t\t\t+Add\n\t\t\t\t")]
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAddTerm,
                  expression: "showAddTerm"
                }
              ],
              staticClass: "term-box",
              style: "border-color:" + _vm.termColor
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newTerm,
                    expression: "newTerm"
                  }
                ],
                ref: "addBox",
                staticClass: "add-box",
                style:
                  "border-color:" + _vm.termColor + ";color:" + _vm.termColor,
                attrs: {
                  type: "text",
                  placeholder: "Term to add",
                  tabindex: "0"
                },
                domProps: { value: _vm.newTerm },
                on: {
                  keyup: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.addTerm(false)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      return _vm.escapeTerm()
                    }
                  ],
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newTerm = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "gemini-btn",
                  on: {
                    click: function($event) {
                      return _vm.addTerm(true)
                    }
                  }
                },
                [_vm._v("Add")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "gemini-btn",
                  on: {
                    click: function($event) {
                      return _vm.cancelTerm()
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ]
          ),
          _vm._v(" "),
          _vm.merged.length == 0
            ? _c("div", [_vm._v(_vm._s(_vm.searchingText))])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(
            _vm.listToShow == "merged"
              ? _vm.merged
              : _vm.dimensions.find(function(d) {
                  return d.name == _vm.listToShow
                }).results,
            function(member) {
              return _c("TinyAdvisor", {
                key: member._id,
                attrs: { member: member, ask: _vm.ask }
              })
            }
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "right-side" }, [
        _vm.ask.sourceparam
          ? _c("div", [
              _vm._v(
                "\n\t\t\t\tFrom " + _vm._s(_vm.ask.sourceparam) + "\n\t\t\t"
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "name-and-links" },
          [
            _c(
              "span",
              {
                staticStyle: { cursor: "help" },
                attrs: { title: _vm.ask.subject + "\n\n " + _vm.ask.text }
              },
              [_vm._v("<?>")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: { href: "/members/" + _vm.asker._id, target: "_blank" }
              },
              [_vm._v(_vm._s(_vm.asker.displayName))]
            ),
            _vm._v(" "),
            _vm._l(_vm.quickTags, function(term, idx) {
              return _c(
                "span",
                {
                  key: "qt:" + idx,
                  style:
                    "color: " +
                    _vm.getTermColor(term.dimension.name) +
                    "; cursor: pointer",
                  on: {
                    click: function($event) {
                      return _vm.doAddEmittedTerm(term)
                    }
                  }
                },
                [_vm._v("\n\t\t\t\t\t/ " + _vm._s(term.tag) + "\n\t\t\t\t")]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "gemini-btn",
            on: {
              click: function($event) {
                return _vm.updateMatchingCriteria()
              }
            }
          },
          [_vm._v("Search")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "gemini-btn",
            on: {
              click: function($event) {
                return _vm.assignDimensionTags()
              }
            }
          },
          [_vm._v("Tag")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "gemini-btn",
            on: {
              click: function($event) {
                return _vm.initialAssign()
              }
            }
          },
          [_vm._v("Assign")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "gemini-btn",
            on: {
              click: function($event) {
                return _vm.removeAllAdvisors()
              }
            }
          },
          [_vm._v("Remove All Advisors")]
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _vm.showFeedback
          ? _c("div", { staticClass: "feedback-row" }, [
              _c("span", { staticClass: "feedback-label" }, [
                _vm._v("Were the tags accurate?")
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "gemini-btn",
                  class: { active: _vm.feedbackRating === "up" },
                  on: {
                    click: function($event) {
                      return _vm.setRating("up")
                    }
                  }
                },
                [_vm._v("👍")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "gemini-btn",
                  class: { active: _vm.feedbackRating === "down" },
                  on: {
                    click: function($event) {
                      return _vm.setRating("down")
                    }
                  }
                },
                [_vm._v("👎")]
              ),
              _vm._v(" "),
              _vm.feedbackRating
                ? _c(
                    "div",
                    { staticClass: "chip-row" },
                    _vm._l(_vm.currentChips, function(chip) {
                      return _c(
                        "span",
                        {
                          key: chip,
                          staticClass: "chip",
                          class: { selected: _vm.selectedChips.includes(chip) },
                          on: {
                            click: function($event) {
                              return _vm.toggleChip(chip)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" + _vm._s(chip) + "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.feedbackRating
                ? _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.feedbackComment,
                        expression: "feedbackComment"
                      }
                    ],
                    staticClass: "feedback-comment",
                    attrs: {
                      placeholder: "Any additional comments...",
                      maxlength: "300"
                    },
                    domProps: { value: _vm.feedbackComment },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.feedbackComment = $event.target.value
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.feedbackRating
                ? _c(
                    "button",
                    {
                      staticClass: "gemini-btn",
                      on: {
                        click: function($event) {
                          return _vm.submitFeedback()
                        }
                      }
                    },
                    [_vm._v("Submit")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "gemini-btn",
                  on: {
                    click: function($event) {
                      _vm.showFeedback = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "info-header" }, [
          _vm._v(
            "\n\t\t\t\tMatching\n\t\t\t\t" +
              _vm._s(
                _vm.ask.recommendedAdvisors
                  ? _vm.ask.recommendedAdvisors.length
                  : 0
              ) +
              " of\n\t\t\t\t" +
              _vm._s(_vm.community.rules.minimum_advisors) +
              " -\n\t\t\t\t" +
              _vm._s(_vm.community.rules.maximum_advisors) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _vm.ask.matchingCriteria && _vm.ask.matchingCriteria.assignment
          ? _c(
              "div",
              [
                _vm._v("\n\t\t\t\tMatch "),
                _c("clicker", {
                  staticStyle: {},
                  model: {
                    value: _vm.ask.matchingCriteria.assignment.initial,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.ask.matchingCriteria.assignment,
                        "initial",
                        $$v
                      )
                    },
                    expression: "ask.matchingCriteria.assignment.initial"
                  }
                }),
                _vm._v("\n\t\t\t\tadd "),
                _c("clicker", {
                  staticStyle: {},
                  model: {
                    value: _vm.ask.matchingCriteria.assignment.refill,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.ask.matchingCriteria.assignment,
                        "refill",
                        $$v
                      )
                    },
                    expression: "ask.matchingCriteria.assignment.refill"
                  }
                }),
                _vm._v("\n\t\t\t\tevery "),
                _c("clicker", {
                  staticStyle: {},
                  model: {
                    value: _vm.ask.matchingCriteria.assignment.days,
                    callback: function($$v) {
                      _vm.$set(_vm.ask.matchingCriteria.assignment, "days", $$v)
                    },
                    expression: "ask.matchingCriteria.assignment.days"
                  }
                }),
                _vm._v(" days\n\t\t\t\tfor "),
                _c("clicker", {
                  staticStyle: {},
                  model: {
                    value: _vm.ask.matchingCriteria.assignment.responses,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.ask.matchingCriteria.assignment,
                        "responses",
                        $$v
                      )
                    },
                    expression: "ask.matchingCriteria.assignment.responses"
                  }
                }),
                _vm._v(" responses\n\t\t\t")
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "outer criteria-info" }, [
          _c("div", [_vm._v("Automatically refill")]),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ask.matchingCriteria.assignment.autoRefill,
                  expression: "ask.matchingCriteria.assignment.autoRefill"
                }
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(
                  _vm.ask.matchingCriteria.assignment.autoRefill
                )
                  ? _vm._i(
                      _vm.ask.matchingCriteria.assignment.autoRefill,
                      null
                    ) > -1
                  : _vm.ask.matchingCriteria.assignment.autoRefill
              },
              on: {
                change: function($event) {
                  var $$a = _vm.ask.matchingCriteria.assignment.autoRefill,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.ask.matchingCriteria.assignment,
                          "autoRefill",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.ask.matchingCriteria.assignment,
                          "autoRefill",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(
                      _vm.ask.matchingCriteria.assignment,
                      "autoRefill",
                      $$c
                    )
                  }
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPanel == "global" && _vm.ask.matchingCriteria,
                expression: "showPanel == 'global' && ask.matchingCriteria"
              }
            ],
            staticClass: "info-panel"
          },
          [
            _c("div", { staticClass: "criteria-header" }, [_vm._v("Filters")]),
            _vm._v(" "),
            _c("div", { staticClass: "outer criteria-info" }, [
              _c("div", [_vm._v("Bypass Engagement Date Filter")]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value:
                        _vm.ask.matchingCriteria.filters
                          .bypassEngagementDateFilter,
                      expression:
                        "\n\t\t\t\t\t\t\t\t\task.matchingCriteria.filters.bypassEngagementDateFilter\n\t\t\t\t\t\t\t\t"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(
                      _vm.ask.matchingCriteria.filters
                        .bypassEngagementDateFilter
                    )
                      ? _vm._i(
                          _vm.ask.matchingCriteria.filters
                            .bypassEngagementDateFilter,
                          null
                        ) > -1
                      : _vm.ask.matchingCriteria.filters
                          .bypassEngagementDateFilter
                  },
                  on: {
                    change: function($event) {
                      var $$a =
                          _vm.ask.matchingCriteria.filters
                            .bypassEngagementDateFilter,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.filters,
                              "bypassEngagementDateFilter",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.filters,
                              "bypassEngagementDateFilter",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(
                          _vm.ask.matchingCriteria.filters,
                          "bypassEngagementDateFilter",
                          $$c
                        )
                      }
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "outer criteria-info" }, [
              _c("div", [_vm._v("Exclude Existing Matches")]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value:
                        _vm.ask.matchingCriteria.filters.excludeExistingMatches,
                      expression:
                        "ask.matchingCriteria.filters.excludeExistingMatches"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(
                      _vm.ask.matchingCriteria.filters.excludeExistingMatches
                    )
                      ? _vm._i(
                          _vm.ask.matchingCriteria.filters
                            .excludeExistingMatches,
                          null
                        ) > -1
                      : _vm.ask.matchingCriteria.filters.excludeExistingMatches
                  },
                  on: {
                    change: function($event) {
                      var $$a =
                          _vm.ask.matchingCriteria.filters
                            .excludeExistingMatches,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.filters,
                              "excludeExistingMatches",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.filters,
                              "excludeExistingMatches",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(
                          _vm.ask.matchingCriteria.filters,
                          "excludeExistingMatches",
                          $$c
                        )
                      }
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "outer criteria-info" }, [
              _c("div", [_vm._v("Bypass Quality Blocking")]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value:
                        _vm.ask.matchingCriteria.filters.bypassQualityBlocking,
                      expression:
                        "ask.matchingCriteria.filters.bypassQualityBlocking"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(
                      _vm.ask.matchingCriteria.filters.bypassQualityBlocking
                    )
                      ? _vm._i(
                          _vm.ask.matchingCriteria.filters
                            .bypassQualityBlocking,
                          null
                        ) > -1
                      : _vm.ask.matchingCriteria.filters.bypassQualityBlocking
                  },
                  on: {
                    change: function($event) {
                      var $$a =
                          _vm.ask.matchingCriteria.filters
                            .bypassQualityBlocking,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.filters,
                              "bypassQualityBlocking",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.filters,
                              "bypassQualityBlocking",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(
                          _vm.ask.matchingCriteria.filters,
                          "bypassQualityBlocking",
                          $$c
                        )
                      }
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm.community.additionalParams.length
              ? _c(
                  "div",
                  {
                    staticClass: "outer criteria-info",
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "10px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "6px"
                        }
                      },
                      [
                        _c("span", [_vm._v("Only in Circle:")]),
                        _vm._v(" "),
                        _c("CustomDropdown", {
                          attrs: {
                            options: _vm.community.additionalParams,
                            placeholder: "Select Circle"
                          },
                          model: {
                            value:
                              _vm.ask.matchingCriteria.filters.circleLimit
                                .ref_code,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.ask.matchingCriteria.filters.circleLimit,
                                "ref_code",
                                $$v
                              )
                            },
                            expression:
                              "ask.matchingCriteria.filters.circleLimit.ref_code"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.ask.matchingCriteria.filters.circleLimit.active,
                          expression:
                            "ask.matchingCriteria.filters.circleLimit.active"
                        }
                      ],
                      staticStyle: { "margin-left": "auto" },
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.ask.matchingCriteria.filters.circleLimit.active
                        )
                          ? _vm._i(
                              _vm.ask.matchingCriteria.filters.circleLimit
                                .active,
                              null
                            ) > -1
                          : _vm.ask.matchingCriteria.filters.circleLimit.active
                      },
                      on: {
                        change: function($event) {
                          var $$a =
                              _vm.ask.matchingCriteria.filters.circleLimit
                                .active,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.ask.matchingCriteria.filters.circleLimit,
                                  "active",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.ask.matchingCriteria.filters.circleLimit,
                                  "active",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.ask.matchingCriteria.filters.circleLimit,
                              "active",
                              $$c
                            )
                          }
                        }
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "criteria-header" }, [
              _vm._v("Equalizers")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "outer criteria-info" }, [
              _c("div", [_vm._v("Normalize Dimensions")]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value:
                        _vm.ask.matchingCriteria.equalizers.normalizeDimensions,
                      expression:
                        "ask.matchingCriteria.equalizers.normalizeDimensions"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(
                      _vm.ask.matchingCriteria.equalizers.normalizeDimensions
                    )
                      ? _vm._i(
                          _vm.ask.matchingCriteria.equalizers
                            .normalizeDimensions,
                          null
                        ) > -1
                      : _vm.ask.matchingCriteria.equalizers.normalizeDimensions
                  },
                  on: {
                    change: function($event) {
                      var $$a =
                          _vm.ask.matchingCriteria.equalizers
                            .normalizeDimensions,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.equalizers,
                              "normalizeDimensions",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.equalizers,
                              "normalizeDimensions",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(
                          _vm.ask.matchingCriteria.equalizers,
                          "normalizeDimensions",
                          $$c
                        )
                      }
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "criteria-header" }, [
              _vm._v("Exclusions")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "outer criteria-info" }, [
              _c("div", [_vm._v("Allow Single Dimension Matches")]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value:
                        _vm.ask.matchingCriteria.exclusions
                          .allowSingleDimensionMatches,
                      expression:
                        "ask.matchingCriteria.exclusions.allowSingleDimensionMatches"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(
                      _vm.ask.matchingCriteria.exclusions
                        .allowSingleDimensionMatches
                    )
                      ? _vm._i(
                          _vm.ask.matchingCriteria.exclusions
                            .allowSingleDimensionMatches,
                          null
                        ) > -1
                      : _vm.ask.matchingCriteria.exclusions
                          .allowSingleDimensionMatches
                  },
                  on: {
                    change: function($event) {
                      var $$a =
                          _vm.ask.matchingCriteria.exclusions
                            .allowSingleDimensionMatches,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.exclusions,
                              "allowSingleDimensionMatches",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.exclusions,
                              "allowSingleDimensionMatches",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(
                          _vm.ask.matchingCriteria.exclusions,
                          "allowSingleDimensionMatches",
                          $$c
                        )
                      }
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "outer criteria-info" }, [
              _c("div", [_vm._v("Strategy Matches Only")]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value:
                        _vm.ask.matchingCriteria.exclusions.strategyMatchesOnly,
                      expression:
                        "ask.matchingCriteria.exclusions.strategyMatchesOnly"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(
                      _vm.ask.matchingCriteria.exclusions.strategyMatchesOnly
                    )
                      ? _vm._i(
                          _vm.ask.matchingCriteria.exclusions
                            .strategyMatchesOnly,
                          null
                        ) > -1
                      : _vm.ask.matchingCriteria.exclusions.strategyMatchesOnly
                  },
                  on: {
                    change: function($event) {
                      var $$a =
                          _vm.ask.matchingCriteria.exclusions
                            .strategyMatchesOnly,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.exclusions,
                              "strategyMatchesOnly",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.ask.matchingCriteria.exclusions,
                              "strategyMatchesOnly",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(
                          _vm.ask.matchingCriteria.exclusions,
                          "strategyMatchesOnly",
                          $$c
                        )
                      }
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "outer criteria-info" }, [
              _c("div", [_vm._v("Cutoff Percentage")]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value:
                        _vm.ask.matchingCriteria.exclusions.cutoffPercentage,
                      expression:
                        "ask.matchingCriteria.exclusions.cutoffPercentage"
                    }
                  ],
                  staticClass: "option-number",
                  attrs: { type: "number" },
                  domProps: {
                    value: _vm.ask.matchingCriteria.exclusions.cutoffPercentage
                  },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.ask.matchingCriteria.exclusions,
                        "cutoffPercentage",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "criteria-header" }, [
              _vm._v("Selection Strategy and Goals")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "outer" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedStrategy,
                      expression: "selectedStrategy"
                    }
                  ],
                  staticClass: "new-picker",
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedStrategy = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      function($event) {
                        return _vm.updateGoals()
                      }
                    ]
                  }
                },
                _vm._l(_vm.strategies, function(strategy) {
                  return _c(
                    "option",
                    { key: strategy, domProps: { value: strategy } },
                    [_vm._v(_vm._s(strategy) + "\n\t\t\t\t\t\t")]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.ask.matchingCriteria.selectionStrategies, function(
              strategy,
              idx
            ) {
              return _c(
                "div",
                { key: strategy[0], staticClass: "outer criteria-info" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        gap: "6px"
                      }
                    },
                    [
                      strategy[2] && strategy[2] > 0
                        ? _c("clicker", {
                            attrs: {
                              mode: "dice",
                              color: "" + _vm.colors[idx]
                            },
                            model: {
                              value:
                                _vm.ask.matchingCriteria.selectionStrategies[
                                  idx
                                ][2],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.ask.matchingCriteria.selectionStrategies[
                                    idx
                                  ],
                                  2,
                                  $$v
                                )
                              },
                              expression:
                                "ask.matchingCriteria.selectionStrategies[idx][2]"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !(strategy[2] && strategy[2] > 0)
                        ? _c(
                            "b",
                            {
                              staticClass: "strategy-dot",
                              style: "color:#" + _vm.colors[idx]
                            },
                            [_vm._v("⬤")]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n\n\t\t\t\t\t\t" +
                          _vm._s(strategy[0]) +
                          "\n\n\t\t\t\t\t\t"
                      ),
                      strategy[0] === "In Circle"
                        ? _c("CustomDropdown", {
                            attrs: {
                              options: _vm.community.additionalParams,
                              placeholder: "Select Circle"
                            },
                            model: {
                              value:
                                _vm.ask.matchingCriteria.selectionStrategies[
                                  idx
                                ][3],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.ask.matchingCriteria.selectionStrategies[
                                    idx
                                  ],
                                  3,
                                  $$v
                                )
                              },
                              expression:
                                "ask.matchingCriteria.selectionStrategies[idx][3]"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("clicker", {
                        attrs: { mode: "number", color: "blue" },
                        model: {
                          value:
                            _vm.ask.matchingCriteria.selectionStrategies[
                              idx
                            ][1],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.ask.matchingCriteria.selectionStrategies[idx],
                              1,
                              $$v
                            )
                          },
                          expression:
                            "ask.matchingCriteria.selectionStrategies[idx][1]"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _vm.showPanel == "dimension" &&
        _vm.ask.matchingCriteria &&
        _vm.matchingCriteriaDim
          ? _c("div", { staticClass: "info-panel" }, [
              _c(
                "div",
                { staticClass: "info-header", style: "color:" + _vm.termColor },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.listToShow) +
                      " Criteria\n\t\t\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "outer criteria-info" }, [
                _c("div", [_vm._v("Weight")]),
                _vm._v(" "),
                _vm.matchingCriteriaDim
                  ? _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.matchingCriteriaDim.weight,
                            expression: "matchingCriteriaDim.weight"
                          }
                        ],
                        staticClass: "option-number",
                        attrs: { type: "number" },
                        domProps: { value: _vm.matchingCriteriaDim.weight },
                        on: {
                          change: function($event) {
                            return _vm.updateWeight()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.matchingCriteriaDim,
                              "weight",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showPanel == "term" &&
        _vm.showingTerm >= 0 &&
        _vm.matchingCriteriaDim &&
        _vm.matchingCriteriaDim.terms
          ? _c("div", { staticClass: "info-panel" }, [
              _c("div", { staticClass: "info-header" }, [
                _vm._v("Term Details")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "outer criteria-info" }, [
                _c("div", [_vm._v("Term")]),
                _vm._v(" "),
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.matchingCriteriaDim.terms[_vm.showingTerm].term,
                        expression:
                          "matchingCriteriaDim.terms[showingTerm].term"
                      }
                    ],
                    staticClass: "option-text",
                    attrs: { type: "text" },
                    domProps: {
                      value: _vm.matchingCriteriaDim.terms[_vm.showingTerm].term
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.matchingCriteriaDim.terms[_vm.showingTerm],
                          "term",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "outer criteria-info" }, [
                _c("div", [_vm._v("Required")]),
                _vm._v(" "),
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.matchingCriteriaDim.terms[_vm.showingTerm]
                            .required,
                        expression:
                          "matchingCriteriaDim.terms[showingTerm].required"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.matchingCriteriaDim.terms[_vm.showingTerm].required
                      )
                        ? _vm._i(
                            _vm.matchingCriteriaDim.terms[_vm.showingTerm]
                              .required,
                            null
                          ) > -1
                        : _vm.matchingCriteriaDim.terms[_vm.showingTerm]
                            .required
                    },
                    on: {
                      change: function($event) {
                        var $$a =
                            _vm.matchingCriteriaDim.terms[_vm.showingTerm]
                              .required,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.matchingCriteriaDim.terms[_vm.showingTerm],
                                "required",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.matchingCriteriaDim.terms[_vm.showingTerm],
                                "required",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.matchingCriteriaDim.terms[_vm.showingTerm],
                            "required",
                            $$c
                          )
                        }
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "outer criteria-info" }, [
                _c("div", [_vm._v("Score")]),
                _vm._v(" "),
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.matchingCriteriaDim.terms[_vm.showingTerm].score,
                        expression:
                          "matchingCriteriaDim.terms[showingTerm].score"
                      }
                    ],
                    staticClass: "option-number",
                    attrs: { type: "number" },
                    domProps: {
                      value:
                        _vm.matchingCriteriaDim.terms[_vm.showingTerm].score
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.matchingCriteriaDim.terms[_vm.showingTerm],
                          "score",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "remove",
                  on: {
                    click: function($event) {
                      return _vm.removeTerm(_vm.showingTerm, $event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t🗑️   Remove\n\t\t\t\t\t" +
                      _vm._s(
                        _vm.matchingCriteriaDim.terms[_vm.showingTerm].term
                      ) +
                      "\n\t\t\t\t"
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("br")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08770e6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08770e6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gemini/Matches.vue
// module id = null
// module chunks = 